var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"my-2"},[_c('b-col',{staticClass:"font-weight-bold",attrs:{"cols":"12"}},[_vm._v(_vm._s(_vm.label))]),_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"border p-1 my-1 base-textbox"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }